module.exports = __webpack_public_path__ + "img/t_0028.0bc96b55.gif";